<template>
  <div>
    <el-aside>
      <SideMenu :items="items"></SideMenu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import SideMenu from "@/components/common/SideMenu";

export default {
  components: {
    SideMenu,
  },
  data() {
    return {
      items: [
        { icon: "el-icon-thumb", index: "test6-1", title: "服务综合展示" },
      ],
    };
  },
};
</script>

<style>
</style>
